// extracted by mini-css-extract-plugin
export var text = "_3v-0";